import { FC } from 'react';
import { Box, Grid, Typography } from '@mui/material';
import useSWR from 'swr';
import { useHistory, useParams } from 'react-router-dom';
import palette from '../../theme/palette';
import { BlogPost } from '../../types/BlogPost';

export const SingleBlogPost: FC = () => {
  const history = useHistory();
  const { id } = useParams<{ id: string }>();

  const { data: blogPost } = useSWR<BlogPost>(`/blogPosts/${id}`, { suspense: true });

  return (
    <Grid container sx={{ mt: '70px', width: '100%', maxWidth: '80vw', mx: 'auto' }}>
      {blogPost?.image && (
        <Grid
          item
          md={12}
          sx={{
            width: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            mb: 10,
          }}
        >
          <Box
            component="img"
            alt={blogPost?.title}
            src={blogPost?.image || ''}
            sx={{
              width: '100%',
              height: 'auto',
              maxWidth: '800px', // Optional: keeps it from being too huge on desktop
              borderRadius: '4px',
            }}
          />
        </Grid>
      )}
      <Grid
        item
        container
        sx={{
          width: '100%',
          maxWidth: '80vw',
          mx: 'auto',
          marginTop: blogPost && blogPost.image ? '0' : '50px',
        }}
      >
        <Grid item md={12}>
          <Typography
            variant="h3"
            style={{ fontWeight: 'bold', color: palette.paper.secondary, marginBottom: '20px' }}
          >
            {blogPost?.title}
          </Typography>
        </Grid>
        <Grid item md={12}>
          <Typography variant="body1" style={{ whiteSpace: 'pre-wrap', wordWrap: 'break-word' }}>
            {blogPost?.post}
          </Typography>
        </Grid>
        <Grid item md={12}>
          <Typography
            variant="h6"
            sx={{
              display: 'inline-flex',
              textDecoration: 'underline',
              fontWeight: 'bold',
              color: palette.paper.secondary,
              my: '70px',
              cursor: 'pointer',
            }}
            onClick={() => history.push('/blog')}
          >
            BACK TO ALL BLOG POSTS
          </Typography>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default SingleBlogPost;
